<template>
  <div class="container">
    <div class="navbar">
      兑换规则
    </div>
    <div class="wrap">
      <div class="subTitle">积分规则:</div>
      <div class="wrapList">
        积分按实际支付金额并充值成功计算，失败不计算积分;1积分=实际支付20P。
      </div>
      <div class="subTitle"> 积分获取方法：</div>

      <ul class="ruleList">
        <li>
          签到，有效用户可签到，每日签到一次，每次1积分。
        </li>
        <li>
          充值积分，充值成功后才计算积分，积分精确到小数点2位，充值失败不送积分。
        </li>
        <li>
          邀请新用户，被邀请的用户需要充值成功后，才赠送积分给邀请者。
        </li>
        <li>领取积分，新老用户可领取弹窗积分。</li>
      </ul>

      <div class="tips">
        禁止各种盗刷积分行为，如发现盗刷行为将扣除相应积分，严重者将进入黑名单。
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'rule'
  }
</script>

<style lang="less">
  .container {
    height: 100vh;
    background-color: #f9f9f9;

    .limit2 {
      overflow: hidden;
      text-overflow: ellipsis;
      /* 超出部分省略号 */
      word-break: break-all;
      /* break-all(允许在单词内换行。) */
      display: -webkit-box;
      /* 对象作为伸缩盒子模型显示 */
      -webkit-box-orient: vertical;
      /* 设置或检索伸缩盒对象的子元素的排列方式 */
      -webkit-line-clamp: 2;
      /* 显示的行数 */
      max-height: 80rpx;
      /* 设置最大高度，根据行高，要几行乘以几倍 */
    }

    .navbar {
      box-sizing: border-box;
      height: 3.125rem;
      margin-bottom: 1.25rem;
      border-bottom: 1px solid #ddd;
      box-shadow: 0 1px 2px #ddd;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1rem;
      font-weight: bold;
      background-color: var(--theme-color);
      color: #fff;

    }

    .wrap {
      padding: 0 15px;
      text-align: justify;
      line-height: 1.5;

      font-size: 16px;

      .subTitle {
        font-weight: bold;
        color: #333;
      }
    }

    .ruleList {
      list-style: auto;
      padding-inline-start: inherit;
      text-align: justify;
    }

    .ruleList li {
      margin-bottom: 5px;
    }

    .tips {
      color: #e4393c;
      font-weight: bold;
    }

    .wrapList {
      margin-top: 16px;
      margin-bottom: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/rule.vue